// src/pages/Home.js (GÜNCEL)
import React from "react";
import Container from "../components/Container";
import SERVICES from "../data/services.json";
import PROJECTS from "../data/references.json";
import SITE from "../data/site.json";

export default function Home() {

  return (
    <>
      {/* HERO */}
      <section className="hero">
        <div
          className="hero-bg"
          role="img"
          aria-label="Şantiye ve iş makinesi arka planı"
        />
        <div className="container hero-inner">
          <div className="hero-content">
            <h1
              className="hero-title"
              dangerouslySetInnerHTML={{
                __html: SITE.heroTitle.replace("<accent>", '<span class="accent">').replace("</accent>", "</span>"),
              }}
            />
            <p className="hero-subtitle">{SITE.heroSubtitle}</p>
            <div className="hero-cta">
              <a href="/services" className="btn ghost">
                Hizmetler
              </a>
            </div>
          </div>
          <div className="hero-media" aria-hidden="true">
            <img
              src="/assets/images/hero.png"
              width="1200"
              height="800"
              loading="eager"
              fetchpriority="high"
              decoding="async"
              alt="Ekskavatör ile hafriyat çalışması"
            />
          </div>
        </div>
      </section>

      {/* HİZMETLER */}
      <Container id="hizmetler" className="pad-top">
        <header className="section-head">
          <h2>Hizmetlerimiz</h2>
          <p>İhtiyacınıza uygun, zamanında ve güvenli çözümler.</p>
        </header>
        <div className="cards">
          {SERVICES.slice(0, 5).map((s) => (
            <article key={s.key} className="card">
              <h3 className="card-title">{s.title}</h3>
              <p className="card-desc">{s.desc}</p>
              <a
                href={`/services/${s.key}`}
                className="card-link"
                aria-label={`${s.title} detay`}
              >
                Detaya git →
              </a>
            </article>
          ))}
        </div>
      </Container>

      {/* NEDEN BİZ (Anasayfa içeriği) */}
      <Container id="neden-biz">
        <header className="section-head">
          <h2>Neden Bizi Tercih Etmelisiniz!</h2>
          <p>
            Bağcı İnşaat Hafriyat, Hafriyat, Kazı ve Çevre Düzenleme işlerinizi zamanında ve sorunsuz bir şekilde teslim etmek, her zaman gerçek referansımız olmuştur. Sektördeki köklü geçmişimiz, uzman kadrosu ve yenilikçi yaklaşımı ile tercih sebebi olmaktadır. Şirketin güvenilirliği ve yüksek kalite standartları, her projede müşteri memnuniyetini garanti eder. 1995 yılından beri edindiği deneyim, her türlü projede en doğru ve etkili çözümleri sunmasını sağlar. Ayrıca, sektördeki en son teknolojileri kullanarak, her zaman en verimli ve yenilikçi çözümleri sunar. Çevreye duyarlılık ilkesi doğrultusunda, sürdürülebilir ve çevre dostu çözümler sunarak, hem doğaya hem de topluma değer katmaktadır.
          </p>
        </header>
        <div className="cards">
          <article className="card">
            <h3 className="card-title">Uzman Kadro</h3>
            <p className="card-desc">
              Deneyimli personel ve modern ekipmanlarımızla kaliteli hizmet.
            </p>
          </article>
          <article className="card">
            <h3 className="card-title">Yenilikçi Yaklaşım</h3>
            <p className="card-desc">
              Sektördeki yenilikleri ve teknolojiyi en verimli şekilde
              kullanırız.
            </p>
          </article>
          <article className="card">
            <h3 className="card-title">Sürdürülebilir Çözümler</h3>
            <p className="card-desc">
              Çevreye duyarlı ve sürdürülebilir uygulamalarla topluma değer
              katarız.
            </p>
          </article>
        </div>
      </Container>

      {/* REFERANSLAR */}
      <Container id="referanslar">
        <header className="section-head">
          <h2>Referanslar</h2>
          <p>Müşterilerimizin memnuniyeti en büyük referansımızdır.</p>
        </header>
        <ReferencesStrip />
      </Container>

      {/* İLETİŞİM CTA */}
      <Container id="teklif">
        <div className="cta">
          <h3>Projenizi Konuşalım</h3>
          <p>Kısa formu doldurun, aynı gün içinde size dönüş yapalım.</p>
          <a href="/contact#form" className="btn primary">
            İletişime Geç
          </a>
        </div>
      </Container>
    </>
  );
}

/* === İç komponent: Referans görsel şeridi (güncel) === */
const RAW_IMAGES = Array.from({ length: 31 }, (_, i) => i + 1);

// Uzantı istisnaları + image_6 hariç
const IMAGES = RAW_IMAGES
  .filter((n) => n !== 6 && n !== 15)
  .map((n) => {
    if (n === 5 || n === 10 || n === 23) return { n, src: `/media/references/image_${n}.jpeg`, ext: "jpeg" };
    if (n === 15 || n === 18) return { n, src: `/media/references/image_${n}.svg`, ext: "svg" };
    return { n, src: `/media/references/image_${n}.png`, ext: "png" };
  });

// Görsel bazlı fit-override'lar (sadece şerit için)
const FIT_OVERRIDES = {
  5: "contain", // image_5 şeritte 'bozuk' görünüyordu → contain
};

function ReferencesStrip() {
  const looped = [...IMAGES, ...IMAGES];

  return (
    <div
      className="refs-strip"
      role="region"
      aria-label="Referans görselleri akışı (otomatik)"
    >
      <div className="refs-fader refs-fader-left" aria-hidden="true" />
      <div className="refs-fader refs-fader-right" aria-hidden="true" />

      <div className="refs-track">
        {looped.map((item, idx) => (
          <div className="refs-item" key={`${idx}-${item.n}`}>
            <img
              src={item.src}
              alt={`Referans görseli ${String(item.n).padStart(2, "0")}`}
              loading="lazy"
              decoding="async"
              draggable="false"
              className="refs-img"
              onError={(e) => (e.currentTarget.style.opacity = "0.3")}
            />
          </div>
        ))}
      </div>
    </div>
  );
}